// src/services/partnershipsApi.js
import axios from 'axios';
import { getJwtToken } from '../utils/auth';
import { getBaseUrl } from '../utils/apiClient';

const partnershipsApiClient = axios.create({
    baseURL: `${getBaseUrl()}/partnerships`,
});

partnershipsApiClient.interceptors.request.use(
    async (config) => {
        const token = await getJwtToken();
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

// ============= PÚBLICO =============

export const getActivePartnerships = async () => {
    const response = await partnershipsApiClient.get('/active');
    return response.data;
};

/**
 * Devuelve el partnership activo que sponsorea una categoría de servicios dada,
 * o null si no hay match (el backend devuelve 204).
 */
export const getSponsorForServiceCategory = async (categoryId) => {
    const response = await partnershipsApiClient.get(`/sponsor/service-category/${categoryId}`);
    if (response.status === 204) return null;
    return response.data;
};

// ============= ADMIN =============

export const getAllPartnerships = async () => {
    const response = await partnershipsApiClient.get('');
    return response.data;
};

export const getPartnership = async (id) => {
    const response = await partnershipsApiClient.get(`/${id}`);
    return response.data;
};

export const createPartnership = async (partnership) => {
    const response = await partnershipsApiClient.post('', partnership);
    return response.data;
};

export const updatePartnership = async (id, partnership) => {
    const response = await partnershipsApiClient.put(`/${id}`, partnership);
    return response.data;
};

export const deletePartnership = async (id) => {
    const response = await partnershipsApiClient.delete(`/${id}`);
    return response.data;
};

/**
 * Warning blando: devuelve la lista de partnerships activos cuyo provider comparte
 * categorías de productos con el provider dado. Se llama desde el form al seleccionar
 * provider, para que el admin vea el aviso antes de confirmar.
 */
export const checkProductCategoryOverlaps = async (productProviderId, excludePartnershipId = null) => {
    const params = { productProviderId };
    if (excludePartnershipId) params.excludePartnershipId = excludePartnershipId;
    const response = await partnershipsApiClient.get('/check-overlaps', { params });
    return response.data;
};
